import { Component } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

@Component({
    selector: 'app-selection-column-header',
    template: `<span class="show-for-sr">Select</span>`,
    standalone: false
})
export class SelectionColumnHeaderComponent implements IHeaderAngularComp {
    agInit(params: IHeaderParams): void {}
    refresh(params: IHeaderParams): boolean { return true; }
}
